import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// !!! MAKE SURE THIS LINE IS HERE !!!
import 'bootstrap/dist/css/bootstrap.min.css'; 
import '@fortawesome/fontawesome-free/css/all.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);